'use client';

import { useOptionalTranslation } from '@/core/components/providers/TranslationProvider';

// Admin-typed free text of the classic header/footer (nav links, footer columns, copyright) in the
// page's language. The translations arrive with the page (app/(store)/layout.tsx →
// /site-config/chrome-labels, cached by the backend), so the first paint and search engines see
// them too — they used to be fetched from the browser after hydration. Untranslated texts keep
// their source wording.
export function useAutoTranslateLabels(_labels: string[], _locale: string): Record<string, string> {
    return useOptionalTranslation()?.labelTranslations ?? {};
}
